/**
 * @generated SignedSource<<0ddc86496df7481b3e7c060541a7fed5>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ECommerce = "AMAZON" | "API" | "BIG_COMMERCE" | "CODE_CANYON" | "C_CLOUD" | "ETSY" | "MAGENTO" | "MAGENTO1" | "NET_SUITE" | "NONE" | "OPEN_CART" | "PRESTA_SHOP" | "SHOPIFY" | "SHOPWARE" | "WIX" | "WOO_COMMERCE";
export type podDoneQuery$variables = Record<PropertyKey, never>;
export type podDoneQuery$data = {
  readonly ecommerceSettings: {
    readonly currencyCode: string | null;
    readonly ecommerceName: ECommerce;
  } | null;
};
export type podDoneQuery = {
  response: podDoneQuery$data;
  variables: podDoneQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "ecommerceName",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "currencyCode",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "podDoneQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "EcommerceSettings",
        "kind": "LinkedField",
        "name": "ecommerceSettings",
        "plural": false,
        "selections": [
          (v0/*:: as any*/),
          (v1/*:: as any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "podDoneQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "EcommerceSettings",
        "kind": "LinkedField",
        "name": "ecommerceSettings",
        "plural": false,
        "selections": [
          (v0/*:: as any*/),
          (v1/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "19439419a436fc9f0f4a3dfa5564c9cf",
    "id": null,
    "metadata": {},
    "name": "podDoneQuery",
    "operationKind": "query",
    "text": "query podDoneQuery {\n  ecommerceSettings {\n    ecommerceName\n    currencyCode\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "07af7652c8c5f72bb60fe541f9a25baa";

export default node;
